import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { formatDate } from "../../../Utils/formatters"
import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import { PAYMENT_STATUS_BADGE } from "../../../Constant/leadConstent";
import Search from "../../../common/Search";
import {
  InventoryTransferList,
  DeleteInventory,
  WhereHouseChangeStatus,
} from "../../../redux/services/InventryTransferService/inventory.Services";
import Pagination from "../../../common/Pagination";
function AllInventryTransferList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalRecords, setTotalRecords] = useState(0);
  const [whereHouse, setWhereHouse] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const [loading, setLoading] = useState(false);
  const fetchInventoryTransferList = async () => {
    try {
      setLoading(true);
      const payload = {
        page,
        search,
        status,
      };
      const res = await InventoryTransferList(payload);
      setWhereHouse(res?.data || []);
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInventoryTransferList();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Inventory List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Inventory List </span>
              </nav>
            </div>
          </div>

          <button
            className="add-btn"
            onClick={() =>
              navigate("/create-transfer-inventroy")
            }
          >
            Transfer Inventory
          </button>
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search WhereHouse..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0 text-nowrap">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Date&Time</th>
                  <th>transfer No.</th>
                  <th >From</th>
                  <th >To</th>
                  <th>Qut.</th>
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {whereHouse.length > 0 ? (
                  whereHouse.map((item, index) => (
                    <tr key={item.id}>
                        <td> {(page - 1) * limit + index + 1}</td>
                      <td>{formatDate(item.transfer_date)}</td>
                      <td>{item.transfer_no}</td>
                      <td>{item.from_warehouse?.warehouse_name}</td>
                      <td >{item.to_warehouse?.warehouse_name}</td>
                      <td>{item.total_quantity}</td>
                      <td>
                        <span
                          className={`source-badge  ${PAYMENT_STATUS_BADGE[item.status?.toLowerCase()]
                            }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              //  dispatch(
                              //    openProductModal({
                              //      type: "view-inventry-transfer",
                              //      title: "View WhereHouse",
                              //      data: item,
                              //    })
                              //  )
                              navigate(`/view-transfer-inventroy/${item.id}`)
                            }
                          >
                            <FaEye />
                          </button>
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              //  dispatch(
                              //    openProductModal({
                              //      type: "edit-inventory-transfer",
                              //      title: "Edit Inventory",
                              //      data: {
                              //        ...item,
                              //        refreshData: fetchInventoryTransferList,
                              //      },
                              //    })
                              //  )
                              navigate(`/edit-transfer-inventroy/${item.id}`)
                            }
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-inventory",
                                  title: "Delete Inventry Row",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteInventory,
                                    refreshData: fetchInventoryTransferList,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllInventryTransferList;
